"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hasOwn = {}.hasOwnProperty;
function classNames() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    for (var i = 0; i < args.length; i++) {
        var arg = args[i];
        if (!arg)
            continue;
        var argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
            classes.push(arg);
        }
        else if (Array.isArray(arg)) {
            classes.push(classNames.apply(null, arg));
        }
        else if (argType === 'object') {
            for (var key in arg) {
                if (hasOwn.call(arg, key) && arg[key]) {
                    classes.push(key);
                }
            }
        }
    }
    return classes.join(' ');
}
exports.classNames = classNames;
exports.default = classNames;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/classnames.js
// module id = 3
// module chunks = 0 1 2 3 4 5 6